var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('label',{staticClass:"search_menu"},[_c('input',{staticClass:"Rechteck-2280 tw-text-sm tw-p-4 italic",attrs:{"type":"search","placeholder":"Suche..."}})])])
}]

export { render, staticRenderFns }